import { Component, inject, PLATFORM_ID } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ImagesService } from '../../../services/general/images.service';
import { MatTableModule } from '@angular/material/table';
import { Institution, InstitutionDetail, } from '../../../interfaces/responses/institution.interface';
import { ActivatedRoute, Router } from '@angular/router';
import { InstitutionService } from '../../../services/institution/institution.service';
import { PaginationComponent } from "../../../components/pagination/pagination.component";
import { SearchComponent } from "../../../shared/search/search.component";
import { InstitutionFilterComponent } from "../../../shared/filter/institution-filter/institution-filter.component";
import { Product } from '../../../interfaces/responses/product-response.interfaces';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { PaginationInterface } from '../../../interfaces/responses/pagination.interface';
import { LoanService } from '../../../services/loan/loan.service';
import { Loan, LoanQueryParams } from '../../../interfaces/responses/loan.interface';
import { LoanStatusStylePipe, LoanStatusLabelPipe } from '../../../pipes/loan-status.pipe';
import {
  ViewNewApplicationComponent
} from "../../../components/card/all-product/view-new-application/view-new-application.component";
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { debounceTime, distinctUntilChanged } from 'rxjs';
import { ConfirmationDialogComponent } from "../../../components/shared/confirmation-dialog/confirmation-dialog.component";
import { ToastService } from '../../../services/general/toast.service';
import { MemberQueryParams } from '../../../interfaces/responses/institution.interface';
import { InstitutionMembers } from '../../../interfaces/responses/institution-members';
import { ProductService } from '../../../services/products/product.service';
import { ProductQueryParams } from '../../../interfaces/responses/product-response.interfaces';
import { CustomInputComponent } from '../../../components/input/custom-input/custom-input.component';
import { IdentityVerificationService } from '../../../services/identity-verification/identity-verification.service';
import { PermissionService } from '../../../services/permission/permission.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ProgressLoaderComponent } from '../../../components/loaders/progress-loader/progress-loader.component';
import { ExportButtonComponent } from '../../../components/buttons/export-button/export-button.component';
import { ExportService } from '../../../services/general/export.service';

@Component({
  selector: 'app-institution-details',
  imports: [
    PaginationComponent,
    SearchComponent,
    InstitutionFilterComponent,
    ViewNewApplicationComponent,
    ReactiveFormsModule,
    CommonModule,
    ConfirmationDialogComponent,
    CustomInputComponent,
    MatTableModule,
    LoanStatusStylePipe,
    LoanStatusLabelPipe,
    ProgressLoaderComponent,
    ExportButtonComponent,
  ],
  templateUrl: './institution-details.component.html',
  styleUrl: './institution-details.component.scss'
})
export class InstitutionDetailsComponent {
  _images = inject(ImagesService);
  permissionService = inject(PermissionService);
  _sanitizer = inject(DomSanitizer);
  route = inject(ActivatedRoute);
  institutionService = inject(InstitutionService);
  private loanService = inject(LoanService);
  private productService = inject(ProductService);
  _router = inject(Router);
  _toast = inject(ToastService);
  exportService = inject(ExportService);
  private identityVerificationService = inject(IdentityVerificationService);
  isViewProduct: boolean = false;
  platformId = inject(PLATFORM_ID)
  institution: InstitutionDetail | null = null;
  institutionId!: string;
  viewLoan!: Loan;
  searchQuery!: FormGroup;
  _fb = inject(FormBuilder);

  goBack(): void {
    this._router.navigate(['/institutions']);
  }

  // Document preview modal
  showDocModal = false;
  activeDocUrl: string = '';

  openDocModal(url: string) {
    this.activeDocUrl = url;
    this.showDocModal = true;
  }

  closeDocModal() {
    this.showDocModal = false;
    this.activeDocUrl = '';
  }

  // View management
  currentView: 'overview' | 'members' | 'applications' | 'products' = 'overview';

  // Member actions
  isDeleteConfirmation: boolean = false;
  isDisableConfirmation: boolean = false;
  isResendConfirmation: boolean = false;
  isResetPinConfirmation: boolean = false;
  isViewMember: boolean = false;
  isEditMember: boolean = false;
  selectedMember: any = null;
  selectedMemberIndex: number = -1;
  editMemberForm!: FormGroup;

  loanQueryParams: LoanQueryParams = {
    paginate: true,
    perPage: 10,
    page: 1,
    productId: '',
    institutionId: '',
    keyword: ''
  };

  loanStatusOptions = [
    { value: 'PENDING_APPROVAL',     label: 'Pending' },
    { value: 'APPROVED',             label: 'Approved' },
    { value: 'ACCEPTED',             label: 'Accepted' },
    { value: 'COUNTERED',            label: 'Countered' },
    { value: 'PROCESSING',           label: 'Processing' },
    { value: 'PENDING_DISBURSEMENT', label: 'Pending Disbursement' },
    { value: 'DISBURSED',            label: 'Disbursed' },
    { value: 'ACTIVE',               label: 'Active' },
    { value: 'REJECTED',             label: 'Rejected' },
    { value: 'DEFAULTED',            label: 'Defaulted' },
    { value: 'COMPLETED',            label: 'Completed' },
    { value: 'CANCELLED',            label: 'Cancelled' },
    { value: 'COUNTER_REJECTED',     label: 'Ctr. Rejected' },
  ];

  memberQueryParams: MemberQueryParams = {
    paginate: true,
    perPage: 10,
    page: 1,
    institutionId: '',
    keyword: ''
  };

  productQueryParams: ProductQueryParams = {
    paginate: true,
    perPage: 10,
    page: 1,
    institutionId: '',
    keyword: ''
  };

  isMembersLoading = false;
  isApplicationsLoading = false;
  isProductsLoading = false;

  memberSearchQuery!: FormGroup;
  productSearchQuery!: FormGroup;

  products: PaginationInterface<Product[]> = {
    data: [],
    meta: {
      totalPages: 0,
      perPage: 0,
      page: 0,
      total: 0
    }
  };
  loans: PaginationInterface<Loan[]> = {
    data: [],
    meta: {
      totalPages: 0,
      perPage: 0,
      page: 0,
      total: 0
    }
  };

  members: PaginationInterface<InstitutionMembers[]> = {
    data: [],
    meta: {
      totalPages: 0,
      perPage: 0,
      page: 0,
      total: 0
    }
  };


  ngOnInit(): void {
    this.searchQuery = this._fb.group({
      name: [''],
    });

    this.memberSearchQuery = this._fb.group({
      keyword: [''],
    });

    this.productSearchQuery = this._fb.group({
      keyword: [''],
    });

    this.editMemberForm = this._fb.group({
      firstName: ['', [Validators.required]],
      lastName: ['', [Validators.required]],
      otherName: [''],
      email: ['', [Validators.required, Validators.email]],
      mobileNumber: ['', [Validators.required]],
      dateOfBirth: [''],
      monthlyIncome: [''],
      creditScore: [''],
      ghanaCardNumber: ['', [Validators.required]],
      accountNumber: [''],
      accountName: [''],
      bankName: [''],
      accountType: [''],
      network: [''],
    });

    if (isPlatformBrowser(this.platformId)) {
      const institutionId = this.route.snapshot.paramMap.get('id');
      if (institutionId) {
        this.institutionId = institutionId;
        this.loanQueryParams.institutionId = institutionId;
        this.memberQueryParams.institutionId = institutionId;
        this.productQueryParams.institutionId = institutionId;
        this.fetchInstitutionById(institutionId);
        this.fetchPaginatedInstitutionApplication();
      }

      this.searchQuery.get('name')?.valueChanges
        .pipe(debounceTime(300), distinctUntilChanged())
        .subscribe((query: string) => {
          this.loanQueryParams.keyword = query.trim();
          this.fetchPaginatedInstitutionApplication()
        });

      this.memberSearchQuery.get('keyword')?.valueChanges
        .pipe(debounceTime(300), distinctUntilChanged())
        .subscribe((query: string) => {
          this.memberQueryParams.keyword = query.trim();
          this.memberQueryParams.page = 1;
          this.fetchPaginatedMembers();
        });

      this.productSearchQuery.get('keyword')?.valueChanges
        .pipe(debounceTime(300), distinctUntilChanged())
        .subscribe((query: string) => {
          this.productQueryParams.keyword = query.trim();
          this.productQueryParams.page = 1;
          this.fetchPaginatedProducts();
        });

    } else {
      console.warn('history is not available (SSR)');
    }
  }


  fetchInstitutionById(id: string) {
    this.institutionService.getInstitutionById(id).subscribe({
      next: (res) => {
        this.institution = res;
      },
      error: (err) => {
        console.error('Error fetching institution by ID:', err);
      }
    });
  }

  // Client-side application filter state (the /loans endpoint doesn't
  // reliably honor status/date-range query params, same as the main
  // Loan Applications and product-overview loan lists).
  private allFetchedLoans: Loan[] = [];
  private clientFilteredLoans: Loan[] = [];
  private activeApplicationFilters: any = null;
  private readonly clientApplicationsPerPage = 10;

  get isApplicationFilterActive(): boolean {
    return this.activeApplicationFilters !== null;
  }

  fetchPaginatedInstitutionApplication() {
    this.isApplicationsLoading = true;
    this.loanService.getPaginatedProductLoans(this.loanQueryParams).subscribe({
      next: (res) => {
        this.loans = res;
        this.isApplicationsLoading = false;
      },
      error: (err) => {
        console.error('Error fetching paginated institution applications:', err);
        this.isApplicationsLoading = false;
      }
    });
  }

  filterApplications(formData: FormGroup) {
    const v = formData.value;
    const hasAnyFilter = Object.values(v).some(val => val !== null && val !== undefined && val !== '');

    if (!hasAnyFilter) {
      this.resetApplicationFilters();
      return;
    }

    this.activeApplicationFilters = v;
    this.isApplicationsLoading = true;
    this.loanService.getPaginatedProductLoans({
      paginate: false,
      institutionId: this.institutionId,
      keyword: this.loanQueryParams.keyword,
    }).subscribe({
      next: (res) => {
        this.allFetchedLoans = res.data;
        this.applyApplicationClientFilters(1);
        this.isApplicationsLoading = false;
      },
      error: (err) => {
        console.error('Error fetching paginated institution applications:', err);
        this.isApplicationsLoading = false;
      }
    });
  }

  private applyApplicationClientFilters(page: number) {
    const f = this.activeApplicationFilters;
    if (!f) return;

    this.clientFilteredLoans = this.allFetchedLoans.filter(loan => {
      if (f.status && loan.status !== f.status) return false;
      if (f.startDate) {
        const loanDate = new Date(loan.created_at || loan.createdAt!);
        if (loanDate < new Date(f.startDate)) return false;
      }
      if (f.endDate) {
        const loanDate = new Date(loan.created_at || loan.createdAt!);
        if (loanDate > new Date(f.endDate + 'T23:59:59')) return false;
      }
      return true;
    });

    const total = this.clientFilteredLoans.length;
    const totalPages = Math.ceil(total / this.clientApplicationsPerPage) || 1;
    const start = (page - 1) * this.clientApplicationsPerPage;

    this.loans = {
      data: this.clientFilteredLoans.slice(start, start + this.clientApplicationsPerPage),
      meta: { page, perPage: this.clientApplicationsPerPage, total, totalPages }
    };
  }

  resetApplicationFilters() {
    this.activeApplicationFilters = null;
    this.allFetchedLoans = [];
    this.clientFilteredLoans = [];
    this.loanQueryParams.startDate = undefined;
    this.loanQueryParams.endDate   = undefined;
    this.loanQueryParams.status    = undefined;
    this.loanQueryParams.page      = 1;
    this.fetchPaginatedInstitutionApplication();
  }

  onPageChange(page: number): void {
    if (this.isApplicationFilterActive) {
      this.applyApplicationClientFilters(page);
      return;
    }
    this.loanQueryParams.page = page;
    this.fetchPaginatedInstitutionApplication();
  }

  onMemberPageChange(page: number): void {
    this.memberQueryParams.page = page;
    this.fetchPaginatedMembers();
  }

  fetchPaginatedMembers() {
    if (!this.institutionId) {
      return;
    }
    this.isMembersLoading = true;
    this.institutionService.getMembers(this.memberQueryParams).subscribe({
      next: (res) => {
        this.members = res;
        this.isMembersLoading = false;
      },
      error: (err) => {
        console.error('Error fetching paginated members:', err);
        this.isMembersLoading = false;
      }
    });
  }

  handleMemberExport(type: 'Excel' | 'PDF' | 'CSV'): void {
    if (!this.members.data || this.members.data.length === 0) {
      this._toast.warning('No data available to export');
      return;
    }

    const exportData = this.members.data.map(member => ({
      'Full Name': [member.firstName, member.lastName, member.otherName].filter(Boolean).join(' '),
      'Email': member.email || '',
      'Mobile Number': member.mobileNumber || '',
      'Date of Birth': member.dateOfBirth ? new Date(member.dateOfBirth).toLocaleDateString() : '',
      'Gender': member.gender || '',
      'Ghana Card Number': member.ghanaCardNumber || '',
      'Ghana Card Verified': member.isGhanaCardVerified ? 'Yes' : 'No',
      'Account Number': member.account?.accountNumber || '',
      'Account Name': member.account?.accountName || '',
      'Bank/Network': member.account?.bankName || member.account?.network || '',
      'Account Type': member.account?.accountType || '',
      'Monthly Income': member.monthlyIncome ?? '',
      'Active Loan Sum': member.activeLoanSum ?? '',
      'Credit Score': member.creditScore ?? '',
      'Occupation': member.kyc?.occupation || '',
      'Status': member.isActive ? 'Active' : 'Inactive'
    }));

    const institutionLabel = this.institution?.name || this.institutionId || 'members';
    const filename = `members_${institutionLabel}_${new Date().toISOString().split('T')[0]}`;

    switch (type) {
      case 'Excel':
        this.exportService.exportToExcel(exportData, filename);
        this._toast.success('Members exported to Excel successfully');
        break;
      case 'PDF':
        this.exportService.exportToPDF(exportData, filename, 'Institution Members');
        this._toast.success('Members exported to PDF successfully');
        break;
      case 'CSV':
        this.exportService.exportToCSV(exportData, filename);
        this._toast.success('Members exported to CSV successfully');
        break;
    }
  }

  onProductPageChange(page: number): void {
    this.productQueryParams.page = page;
    this.fetchPaginatedProducts();
  }

  fetchPaginatedProducts() {
    if (!this.productQueryParams.institutionId) {
      const institutionId = this.route.snapshot.paramMap.get('id');
      if (institutionId) {
        this.institutionId = institutionId;
        this.productQueryParams.institutionId = institutionId;
      } else {
        return;
      }
    }
    this.isProductsLoading = true;
    this.productService.getPaginatedProducts(this.productQueryParams).subscribe({
      next: (res) => {
        this.products = res;
        this.isProductsLoading = false;
      },
      error: (err) => {
        console.error('Error fetching paginated products:', err);
        this.isProductsLoading = false;
      }
    });
  }

  onProductSearchEnter(event: Event) {
    event.preventDefault();
    event.stopPropagation();
    const keyword = this.productSearchQuery.get('keyword')?.value?.trim() || '';
    this.productQueryParams.keyword = keyword;
    this.productQueryParams.page = 1;
    this.fetchPaginatedProducts();
  }

  onViewProduct(product: Product) {
    this._router.navigate(
      ['product-details', product?.id],
      { state: { id: product?.id, name: product?.name } },
    )
  }

  onCloseApplication() {
    this.isViewProduct = false;
  }

  onViewLoanProduct(event: Loan) {
    this.viewLoan = event;
    this.isViewProduct = true;
  }

  onCloseViewProduct() {
    this.isViewProduct = false;
  }

  onLoanAction(updatedLoan: Loan): void {
    // Update the specific loan in the list with the latest data
    if (updatedLoan?.id && this.loans.data) {
      const index = this.loans.data.findIndex(loan => loan.id === updatedLoan.id);
      if (index !== -1) {
        // Update the loan in the array
        this.loans.data[index] = updatedLoan;
        // Create a new array reference to trigger change detection
        this.loans = {
          ...this.loans,
          data: [...this.loans.data]
        };
      }

      // Also update viewLoan if it's the same loan being viewed
      if (this.viewLoan?.id === updatedLoan.id) {
        this.viewLoan = updatedLoan;
      }
    }
  }

  routeToPage(link: string) {
    this._router.navigate(['products'])
  }

  // View Management
  showOverview() {
    this.currentView = 'overview';
  }

  showMembers() {
    this.currentView = 'members';
    if (this.institutionId) {
      this.fetchPaginatedMembers();
    }
  }

  showApplications() {
    this.currentView = 'applications';
  }

  showProducts() {
    this.currentView = 'products';
    // Always get institutionId from route to ensure it's current
    const institutionId = this.route.snapshot.paramMap.get('id');
    if (institutionId) {
      this.institutionId = institutionId;
      this.productQueryParams.institutionId = institutionId;
      this.fetchPaginatedProducts();
    } else {
      console.warn('Cannot show products: institutionId not found in route');
    }
  }

  // Member Actions
  showDeleteConfirmation(member: any, index: number) {
    this.selectedMember = member;
    this.selectedMemberIndex = index;
    this.isDeleteConfirmation = true;
  }

  cancelDelete() {
    this.isDeleteConfirmation = false;
    this.selectedMember = null;
    this.selectedMemberIndex = -1;
  }

  confirmDelete() {
    if (!this.selectedMember || !this.selectedMember.id || !this.institutionId) {
      this.cancelDelete();
      return;
    }

    this.institutionService.deleteMember(this.institutionId, this.selectedMember.id).subscribe({
      next: () => {
        // Remove from local array
        if (this.members.data) {
          this.members.data = this.members.data.filter(m => m.id !== this.selectedMember?.id);
          this.members.meta.total = (this.members.meta.total || 0) - 1;
        }
        this._toast.success('Member deleted successfully');
        this.cancelDelete();
      },
      error: (error) => {
        console.error('Error deleting member:', error);
        this._toast.error('Failed to delete member. Please try again.');
        this.cancelDelete();
      }
    });
  }

  showDisableConfirmation(member: any, index: number) {
    this.selectedMember = member;
    this.selectedMemberIndex = index;
    this.isDisableConfirmation = true;
  }

  getMemberStatusAction(): string {
    if (this.selectedMember?.isActive) {
      return 'Disable';
    }
    return 'Enable';
  }

  getMemberStatusMessage(): string {
    if (this.selectedMember?.isActive) {
      return 'Are you sure you want to disable this member?';
    }
    return 'Are you sure you want to enable this member?';
  }

  cancelDisable() {
    this.isDisableConfirmation = false;
    this.selectedMember = null;
    this.selectedMemberIndex = -1;
  }

  confirmDisable() {
    if (this.selectedMember && this.institutionId && this.selectedMember.id) {
      this.institutionService.toggleMemberStatus(this.institutionId, this.selectedMember.id).subscribe({
        next: (res) => {
          // Update the member in the local array
          if (this.members.data) {
            const index = this.members.data.findIndex(m => m.id === res.id);
            if (index !== -1) {
              this.members.data[index] = res;
            }
          }
          const status = res.isActive ? 'enabled' : 'disabled';
          this._toast.success(`Member ${status} successfully`);
          this.cancelDisable();
        },
        error: (err) => {
          console.error('Error toggling member status:', err);
          this._toast.error('Failed to update member status');
          this.cancelDisable();
        }
      });
    } else {
      this.cancelDisable();
    }
  }

  viewMember(member: any) {
    this.selectedMember = member;
    this.isViewMember = true;
  }

  closeViewMember() {
    this.isViewMember = false;
    this.selectedMember = null;
  }

  editMember(member: any) {
    this.selectedMember = member;
    this.isEditMember = true;

    // Format date of birth for date input
    let dateOfBirthValue = '';
    if (member.dateOfBirth) {
      const date = new Date(member.dateOfBirth);
      if (!isNaN(date.getTime())) {
        dateOfBirthValue = date.toISOString().split('T')[0];
      }
    }

    // Populate form with member data
    this.editMemberForm.patchValue({
      firstName: member.firstName || '',
      lastName: member.lastName || '',
      otherName: member.otherName || '',
      email: member.email || '',
      mobileNumber: member.mobileNumber || '',
      dateOfBirth: dateOfBirthValue,
      monthlyIncome: member.monthlyIncome || '',
      creditScore: member.creditScore || '',
      ghanaCardNumber: member.ghanaCardNumber || '',
      accountNumber: member.account?.accountNumber || '',
      accountName: member.account?.accountName || '',
      bankName: member.account?.bankName || '',
      accountType: member.account?.accountType || '',
      network: member.account?.network || '',
    });
  }

  closeEditMember() {
    this.isEditMember = false;
    this.selectedMember = null;
    this.editMemberForm.reset();
  }

  showResendConfirmation(member: InstitutionMembers) {
    // Check if user is already verified
    if (member.isGhanaCardVerified === true) {
      this._toast.info('User is already verified');
      return;
    }

    this.selectedMember = member;
    this.isResendConfirmation = true;
  }

  cancelResend() {
    this.isResendConfirmation = false;
    this.selectedMember = null;
  }

  confirmResend() {
    // The API requires 'userId' — try both fields since the backend may return either
    const userId = this.selectedMember?.userId || this.selectedMember?.id;
    if (!userId) {
      this._toast.error('Member ID is required');
      this.cancelResend();
      return;
    }
    this.identityVerificationService.resendVerification(userId).subscribe({
      next: () => {
        this._toast.success('Verification link sent successfully');
        this.cancelResend();
      },
      error: (error: HttpErrorResponse) => {
        if (error.status === 400) {
          this._toast.error(error?.error?.message || 'Bad request. Please try again.');
        } else {
          this._toast.error('Failed to send verification link. Please try again.');
        }
        this.cancelResend();
      }
    });
  }

  showResetPinConfirmation(member: InstitutionMembers) {
    this.selectedMember = member;
    this.isResetPinConfirmation = true;
  }

  cancelResetPin() {
    this.isResetPinConfirmation = false;
    this.selectedMember = null;
  }

  confirmResetPin() {
    // The API requires 'userId' — try both fields since the backend may return either
    const userId = this.selectedMember?.userId || this.selectedMember?.id;
    if (!userId) {
      this._toast.error('Member ID is required');
      this.cancelResetPin();
      return;
    }
    this.identityVerificationService.resetPin(userId).subscribe({
      next: () => {
        this._toast.success('PIN reset successfully');
        this.cancelResetPin();
      },
      error: (error: HttpErrorResponse) => {
        this._toast.error(error?.error?.message || 'Failed to reset PIN. Please try again.');
        this.cancelResetPin();
      }
    });
  }

  saveMemberChanges() {
    if (this.editMemberForm.valid && this.selectedMember && this.institutionId) {
      const formValue = this.editMemberForm.value;
      const payload: Record<string, any> = {
        firstName: formValue.firstName,
        lastName: formValue.lastName,
        otherName: formValue.otherName || undefined,
        email: formValue.email,
        mobileNumber: formValue.mobileNumber,
        dateOfBirth: formValue.dateOfBirth ? new Date(formValue.dateOfBirth).toISOString() : undefined,
        monthlyIncome: formValue.monthlyIncome || undefined,
        creditScore: formValue.creditScore || undefined,
        ghanaCardNumber: formValue.ghanaCardNumber,
      };
      if (formValue.accountNumber) payload['accountNumber'] = formValue.accountNumber;
      if (formValue.accountName) payload['accountName'] = formValue.accountName;
      if (formValue.bankName) payload['bankName'] = formValue.bankName;
      if (formValue.accountType) payload['accountType'] = formValue.accountType;
      if (formValue.network) payload['network'] = formValue.network;
      this.institutionService.updateMember(this.institutionId, this.selectedMember.id, payload).subscribe({
        next: (updatedMember) => {
          if (this.members.data) {
            const index = this.members.data.findIndex(m => m.id === updatedMember.id);
            if (index !== -1) {
              this.members.data[index] = updatedMember;
              this.members = { ...this.members, data: [...this.members.data] };
            }
          }
          this._toast.success('Member information updated successfully');
          this.closeEditMember();
        },
        error: (err) => {
          console.error('Error updating member:', err);
          const messages = err?.error?.message ?? err?.error?.response_message;
          const message = Array.isArray(messages) ? messages.join(', ') : (messages || 'Failed to update member. Please try again.');
          this._toast.error(message);
        }
      });
    } else {
      Object.keys(this.editMemberForm.controls).forEach(key => {
        this.editMemberForm.get(key)?.markAsTouched();
      });
    }
  }

  getSafeUrl(url: string): SafeResourceUrl {
    try {
      const parsed = new URL(url);
      if (parsed.protocol !== 'https:' && parsed.protocol !== 'http:') {
        return this._sanitizer.bypassSecurityTrustResourceUrl('');
      }
    } catch {
      return this._sanitizer.bypassSecurityTrustResourceUrl('');
    }
    return this._sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  getFileType(url: string): 'image' | 'pdf' | 'other' {
    const ext = url.split('?')[0].split('.').pop()?.toLowerCase() || '';
    if (['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg'].includes(ext)) return 'image';
    if (ext === 'pdf') return 'pdf';
    return 'other';
  }

  getFileNameFromUrl(url: string): string {
    try {
      const urlObj = new URL(url);
      const pathname = urlObj.pathname;
      const fileName = pathname.split('/').pop() || 'Document';
      return decodeURIComponent(fileName);
    } catch (e) {
      // If URL parsing fails, try to extract filename from the string
      const parts = url.split('/');
      const fileName = parts[parts.length - 1] || 'Document';
      return decodeURIComponent(fileName.split('?')[0]);
    }
  }

  downloadDocument(url: string): void {
    try {
      const fileName = this.getFileNameFromUrl(url);
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error('Error downloading document:', error);
      this._toast.error('Failed to download document');
    }
  }

}
